import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import messages from '../locales/messages.json'

Vue.use(VueI18n)

const locale = Cookies.get('lang')
const lang_type = Cookies.get('lang_type')

if (locale && messages[locale] && lang_type && lang_type !== 'enterprise') {
  Object.assign(messages[locale], messages[`${locale}-${lang_type}`])
}

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: locale || 'zh-CN', // set locale
  messages
})

export const setLanguageType = (type = 'enterprise') => {
  if (type === 'enterprise') {
    if (lang_type !== undefined && lang_type !== 'enterprise') {
      Cookies.remove('lang_type')
      window.location.reload()
    }
  } else {
    if (lang_type !== type) {
      Cookies.set('lang_type', type, { expires: 30 })
      window.location.reload()
    }
  }
}
